import { formatNumber, getRatePrecision } from 'utils/format-number'
import { serviceInfoPopup } from './handle-actual-offers'
import { MarketBrief } from 'models/market'

const addClassToTrendElement = ($trendElement: HTMLSpanElement, trendDirection: string): void => {
  if (trendDirection === 'up' || trendDirection === 'down') $trendElement.classList.add(`is-${trendDirection}`)
}

const updateRateTrend = (
  trendDirection: string,
  forexTrend: string,
  $trendElement: HTMLSpanElement,
  $trendForexElement: HTMLSpanElement,
): void => {
  if ($trendElement) {
    $trendElement.classList.remove('is-up', 'is-down')
    addClassToTrendElement($trendElement, trendDirection)
  }

  if ($trendForexElement) {
    $trendForexElement.classList.remove('is-up', 'is-down')
    addClassToTrendElement($trendForexElement, forexTrend)
  }
}

const updateRate = (
  currencyPair: string,
  direction: string,
  rate: MarketBrief,
  $singleRateElement: HTMLDivElement,
): void => {
  const actualRate = direction === 'bid' ? rate.bestOffers.bid_now : rate.bestOffers.ask_now
  const trendDirection = direction === 'bid' ? rate.bestOffers.bid_trend : rate.bestOffers.ask_trend
  const forexRateActual = rate.bestOffers.forex_now

  const $rateElement = $singleRateElement.querySelector<HTMLSpanElement>('[data-rate-value]')
  const $rateForexElement = $singleRateElement.querySelector<HTMLSpanElement>('[data-forex-value]')
  const $trendElement = $singleRateElement.querySelector<HTMLSpanElement>('[data-rate-trend]')
  const $trendForexElement = $singleRateElement.querySelector<HTMLSpanElement>('[data-forex-trend]')
  const ratePrecision = getRatePrecision(currencyPair)

  if ($rateElement) {
    $rateElement.textContent = `${formatNumber(actualRate || 0, ratePrecision)} ${currencyPair.substring(4)}`
  }

  if ($rateForexElement) {
    $rateForexElement.textContent = `${formatNumber(forexRateActual || 0, ratePrecision)} ${currencyPair.substring(4)}`
  }

  updateRateTrend(trendDirection, rate.bestOffers.forex_trend, $trendElement, $trendForexElement)
}

const updateWidgetUI = ($element: HTMLDivElement, currencyPair: string, payload): void => {
  if (!payload) return

  const $directionFragments = $element.querySelectorAll<HTMLDivElement>('[data-rate-direction]')
  $directionFragments.forEach(($singleRateElement) => {
    updateRate(currencyPair, $singleRateElement.dataset.rateDirection, payload, $singleRateElement)
  })
}

export const initHelpTip = (): void => {
  const $signHolder = document.querySelector<HTMLSpanElement>('.actual-single-rate__sign-holder')
  const $infoPopup = document.querySelector<HTMLSpanElement>('.actual-single-rate__answer-info')

  serviceInfoPopup($signHolder, $infoPopup)
}

export function handleFeaturedRatesUpdate(payload: MarketBrief): void {
  const $rateElements = document.querySelectorAll<HTMLDivElement>('[data-rate]')
  $rateElements.forEach(($singleRateElement) => {
    const currencyPair = payload.pair
    updateWidgetUI($singleRateElement, currencyPair, payload)
  })
}
